export const hasData = (data: any[]) => !!(data && data.length > 0);
